import React, { useState } from "react";
import ImageWithBasePath from "../../core/common/imageWithBasePath";
import { Link } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import { forgotPassword } from "./authenticationAPI";

const ForgotPassword = () => {
  const route = all_routes;
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);


  const handleForgotPassword = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError("");
  
    try {
      const response = await forgotPassword(email, "https://sinnovar-uat.vercel.app/verify-forgot");
  
      if (response.status === 200) {
        setMessage("Password reset link sent to your email.");
      } else {
        setError("Failed to send reset link.");
      }
    } catch (err) {
      setError("Error sending reset link.");
      console.error("Forgot Password Error:", err);
    }
  
    setLoading(false);
  };

  return (
    <div className="account-content">
      <div className="d-flex align-items-center justify-content-center flex-wrap w-100 vh-100 overflow-hidden account-bg-02">
        <div className="d-flex align-items-center justify-content-center flex-wrap vh-100 overflow-auto p-4 w-50 bg-backdrop">
          <form className="flex-fill" onSubmit={handleForgotPassword}>
            <div className="mx-auto mw-450">
              <div className="text-center mb-4">
                <ImageWithBasePath
                  src="assets/img/logo.svg"
                  className="img-fluid"
                  alt="Logo"
                />
              </div>
              <div className="mb-4">
                <h4 className="mb-2 fs-20">Forgot Password?</h4>
                <p>
                  If you forgot your password, we’ll email you instructions to reset it.
                </p>
              </div>
              {error && <p className="text-danger">{error}</p>}
              {message && <p className="text-success">{message}</p>}
              <div className="mb-3">
                <label className="col-form-label">Email Address</label>
                <div className="position-relative">
                  <span className="input-icon-addon">
                    <i className="ti ti-mail" />
                  </span>
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="form-control"
                    required
                  />
                </div>
              </div>
              <div className="mb-3">
                <button type="submit" className="btn btn-primary w-100" disabled={loading}>
                  {loading ? "Sending..." : "Submit"}
                </button>
              </div>
              <div className="mb-3 text-center">
                <h6>
                  Return to{" "}
                  <Link to={route.login} className="text-purple link-hover">
                    Login
                  </Link>
                </h6>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
